export enum Error {
  NOT_FOUND,
  SYSTEM_ERROR,
  LOGIN_FAILED,
  NOT_ALLOWED,
  DATA_ALREADY_ADDED,
  USER_SIGNED_OUT,
}
